import { render, staticRenderFns } from "./project-modal.component.vue?vue&type=template&id=0db95bcb&scoped=true&"
import script from "./project-modal.component.vue?vue&type=script&lang=ts&"
export * from "./project-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./project-modal.component.vue?vue&type=style&index=0&id=0db95bcb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db95bcb",
  null
  
)

export default component.exports